import * as d3 from "d3";
import { colorsMaps } from "../../constants/colorsArea";
import { isMobile } from "../../utils/screenValidations/screen";

export const mouseEnter = (node) => {
    const selectCircles = document.querySelectorAll(`circle.circles`);
    selectCircles.forEach((circle) => {
        const idCircle = circle.getAttribute("id");
        const findRelated = node.related_roles.find((related) => related.role_id == idCircle);
        if (idCircle == node.role_id || !!findRelated) {
            if (idCircle == node.role_id) circle.setAttribute("stroke", `${node.color}80`);
        } else {
            circle.classList.add(`circleDisabled`);
            circle.parentNode.childNodes[1]?.setAttribute("opacity", "1");
        }
    });
};

// positions of texts inside circles based in length of text
const fixedText = {
    1: 0,
    2: -1,
    3: -3.5,
    4: -5,
    5: -7.5,
    6: -10,
};

export const mouseLeave = () => {
    const selectLines = document.querySelectorAll(`.linkActive`);
    const selectCircles = document.querySelectorAll(`circle.circles`);

    selectLines.forEach((line) => {
        line.remove();
    });
    selectCircles.forEach((circle) => {
        circle.removeAttribute("stroke");
        circle.classList.remove("circleDisabled");
        circle.parentNode.childNodes[1]?.removeAttribute("opacity");
    });
};

export function elementsD3js(svgElement, data = undefined) {
    if (document.querySelector(".container-nodes")) return;
    const gContainer = svgElement && data && svgElement.append("g").attr("class", "container-nodes");
   
    const containerGrap = gContainer.selectAll("g").data(data.nodes).enter();
    const node =
        svgElement &&
        data &&
        containerGrap
            .append("g")
            .attr("class", "nodes")
            .attr("id", ({ role_id }) => `idNodes${role_id}`)
            .attr("profile-id", ({ profile_id }) => `${profile_id}`)
            .attr("trajectory-id", ({ trajectory_id }) => `${trajectory_id}`)
            .attr("areas-ref", ({ areas }) => `${areas.map((el) => el.id).join(",")}`);

    const circle =
        svgElement &&
        data &&
        node
            .append("circle")
            .attr("r", 20)
            .attr("class", "circles")
            .attr("id", ({ role_id }) => `${role_id}`)
            .attr("fill", (d) => colorsMaps.find((el) => el.trajectory_id === d.trajectory_id)?.color || "green")
            .attr("cx", ({ x }) => x)
            .attr("cy", ({ y }) => y);

    const texts = svgElement
        .selectAll("g.nodes")
        .append("text")
        .attr("id", (d) => `textId${d.role_id}`)
        .attr("font-size", "4px")
        .attr("fill", "white")
        .attr("x", ({ x }) => x)
        .attr("y", ({ y }) => y)
        .each((d) => {
            var arr = d.role.split(" ");
            for (var i = 0; i < arr.length; i++) {
                d3.select(`#textId${d.role_id}`)
                    .append("tspan")
                    .text(arr[i])
                    .attr("dy", i ? "1.2em" : fixedText[arr.length])
                    .attr("x", d.x)
                    .attr("text-anchor", "middle")
                    .attr("class", "tspan" + i);
            }
        });

    return {
        texts,

        circle,
        node,
        mouseEnter,
        mouseLeave,
    };
}
